import { ReactNode } from 'react';
import { ApolloError } from '@apollo/client';
import Error from 'approot/errors/error';
import NotFound from 'approot/errors/not-found';
import { LayoutLoadingContainer } from './layout.styles';
import Bouncer from '../bouncer/bouncer';

export type LayoutContentProps = {
  children?: ReactNode;
  page?: () => ReactNode;
  loading?: boolean;
  error?: ApolloError;
  errorNotFound?: boolean;
};

export const renderLayoutContent = (props: LayoutContentProps) => {
  if (props.errorNotFound) {
    return (
      <Error>
        <NotFound />
      </Error>
    );
  } else if (props.error) {
    return <Error error={props.error} />;
  } else if (props.loading) {
    return (
      <LayoutLoadingContainer>
        <Bouncer />
      </LayoutLoadingContainer>
    );
  } else if (props.page) {
    return props.page();
  } else {
    return props.children;
  }
};
